module.exports = __webpack_public_path__ + "ab9a4395ec21a432.svg";